import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import {
	EditVideoStudioContext,
	IEditVideoStudioContext,
} from '../editVideoStudioModalContext/editVideoStudioModalState/editVideoStudioModalContext';
import style from './BtnBlock.module.scss';
import { useCompareFormData } from 'hooks/useCompareFormData';

const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, initialFormData, name } =
		useContext<IEditVideoStudioContext>(EditVideoStudioContext);

	const currentFormData = {
		name,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={style.btnWrapper}>
				<Button className={style.cancelBtn} theme="secondary" onClick={handleCancel}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" disabled={isEqualFormData}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
